import ProgressLine from "./ProgressLine";
import { useState, useEffect } from "react";
const completionLevels = [
    'Not Started',//0
    'Started',//1
    'Partially Done',//2
    'Halfway Done',//3
    'Mostly Done',//4
    'Almost Done',//5
    'Completed',//6
]
export default function DevelopmentTree({ index, goals, completion, editable, updateCompletion }) {
    const offsetUnits = { y: 15, x: 20 };
    const padding = 6
    const width = goals.length * offsetUnits.x + padding * 2;
    const height = offsetUnits.y * 6 + 54 + padding * 2;
    const markerR = 1.2;
    const [titleIndex, setTitleIndex] = useState(null);
    useEffect(() => {
        setTitleIndex(completion)
        //console.log("completion:", completion)
    }, [completion]);
    return (
        <div style={{ padding: 5, display: 'grid', placeItems: 'center' }}>
            <h4 style={{ textAlign: 'center', fontWeight: 'bold' }}>Goal Status:</h4>
            <svg overflow="visible" role="img" aria-label="Development Tree" viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg"
                style={{
                    width: width,
                    height: height,
                }}
            >
                <defs>
                    <marker
                        id="circle-black"
                        markerWidth={markerR * 2}
                        markerHeight={markerR * 2}
                        orient="auto"
                        refX={markerR}
                        refY={markerR}
                    >
                        <circle cx={markerR} cy={markerR} r={markerR} fill='black' />
                    </marker>
                    <marker
                        id="circle-white"
                        markerWidth={markerR * 2}
                        markerHeight={markerR * 2}
                        orient="auto"
                        refX={markerR}
                        refY={markerR}
                    >
                        <circle cx={markerR} cy={markerR} r={markerR} fill='white' />
                    </marker>
                    <marker
                        id="circle-orange"
                        markerWidth={markerR * 2}
                        markerHeight={markerR * 2}
                        orient="auto"
                        refX={markerR}
                        refY={markerR}
                    >
                        <circle cx={markerR} cy={markerR} r={markerR} fill='var(--orng)' />
                    </marker>
                </defs>
                <g
                    fill="none" >
                    {goals.map((goal, i) => <ProgressLine goal={goal} index={i} currentIndex={index} length={goals.length} key={i} offsetUnits={offsetUnits} />)}
                    <ProgressLine
                        active={true}
                        editable={editable}
                        goal={goals[index]}
                        index={index}
                        length={goals.length}
                        offsetUnits={offsetUnits}
                        updateCompletion={updateCompletion}
                        updateTitleIndex={setTitleIndex}
                        completion={completion}
                    />
                </g>
            </svg>
            <div style={{
                textAlign: 'center',
                color: 'white',
                backgroundColor: 'var(--black50)',
                padding: '2px 10px',
                borderRadius: 20,
                fontSize: 14,
                marginTop: 5
            }}>{completionLevels[titleIndex] || "Not Set"}</div>
        </div>
    )
}
